import { SECTIONS } from './sections.data'
import {
  TRUCK_STANDARD_FIELDS,
  TRAILER_STANDARD_FIELDS,
  TRUCK_ADDITIONAL_FIELDS,
  TRAILER_ADDITIONAL_FIELDS,
  TRUCK_CONDITIONAL_FIELDS,
  TRAILER_CONDITIONAL_FIELDS,
} from './conditionalFields.data'
import type { SectionDefinition } from '@/types'

const findSection = (id: string) => SECTIONS.find((s) => s.id === id)!

export const ALL_SECTIONS: SectionDefinition[] = [
  findSection('basic-information'),
  { ...findSection('standard-equipment'), fields: [...TRUCK_STANDARD_FIELDS, ...TRAILER_STANDARD_FIELDS] },
  { ...findSection('additional-options'), fields: [...TRUCK_ADDITIONAL_FIELDS, ...TRAILER_ADDITIONAL_FIELDS] },
  { ...findSection('body-information'), fields: [] },
  { ...findSection('vehicle-condition'), fields: [...TRUCK_CONDITIONAL_FIELDS, ...TRAILER_CONDITIONAL_FIELDS] },
]

export const FIELD_LABEL_MAP: Record<string, string> = {}
export const FIELD_TYPE_MAP: Record<string, string> = {}
for (const section of ALL_SECTIONS) {
  for (const field of section.fields) {
    FIELD_LABEL_MAP[field.id] = field.label
    FIELD_TYPE_MAP[field.id] = field.type
  }
}
